import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Settings = () => {
    const [activeSection, setActiveSection] = useState('general');
    const [settings, setSettings] = useState({
        clinicName: 'Evoo Medical Clinic',
        email: 'contact@evoomedical.ro',
        phone: '+40 21 123 4567',
        address: 'Strada Clinicilor 1, Bucharest, Romania',
        workingHours: {
            monday: { start: '08:00', end: '20:00' },
            tuesday: { start: '08:00', end: '20:00' },
            wednesday: { start: '08:00', end: '20:00' },
            thursday: { start: '08:00', end: '20:00' },
            friday: { start: '08:00', end: '20:00' },
            saturday: { start: '09:00', end: '14:00' },
            sunday: { start: '', end: '' }
        },
        notifications: true,
        emailAlerts: true,
        smsAlerts: false,
        appointmentReminders: true,
        defaultSlotDuration: 20,
        maxAdvanceBooking: 30,
        onlineBooking: true,
        emergencyContact: '+40 112',
        language: 'ro',
        timezone: 'Europe/Bucharest'
    });

    const handleSaveSettings = () => {
        // Simulate saving settings
        alert('Setările au fost salvate cu succes!');
    };

    const updateSetting = (key, value) => {
        setSettings(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const updateWorkingHours = (day, type, value) => {
        setSettings(prev => ({
            ...prev,
            workingHours: {
                ...prev.workingHours,
                [day]: {
                    ...prev.workingHours[day],
                    [type]: value
                }
            }
        }));
    };

    return (
        <div className="settings-page">
            <div className="page-navigation-header">
                <div className="nav-header-content">
                    <NavLink to="/dashboard" className="back-to-dashboard">
                        ← Înapoi la Dashboard
                    </NavLink>
                    <div className="quick-nav">
                        <NavLink to="/patients" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Pacienți
                        </NavLink>
                        <NavLink to="/staff" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Personal
                        </NavLink>
                        <NavLink to="/reports" className={({ isActive }) => isActive ? "quick-nav-link active" : "quick-nav-link"}>
                            Rapoarte
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="page-header">
                <h1>Setări Sistem</h1>
                <p>Configurarea parametrilor aplicației medicale</p>
            </div>

            <div className="settings-container">
                <div className="settings-sidebar">
                    <button
                        className={`sidebar-btn ${activeSection === 'general' ? 'active' : ''}`}
                        onClick={() => setActiveSection('general')}
                    >
                        Setări Generale
                    </button>
                    <button
                        className={`sidebar-btn ${activeSection === 'working-hours' ? 'active' : ''}`}
                        onClick={() => setActiveSection('working-hours')}
                    >
                        Program Lucru
                    </button>
                    <button
                        className={`sidebar-btn ${activeSection === 'notifications' ? 'active' : ''}`}
                        onClick={() => setActiveSection('notifications')}
                    >
                        Notificări
                    </button>
                    <button
                        className={`sidebar-btn ${activeSection === 'booking' ? 'active' : ''}`}
                        onClick={() => setActiveSection('booking')}
                    >
                        Programări
                    </button>
                    <button
                        className={`sidebar-btn ${activeSection === 'security' ? 'active' : ''}`}
                        onClick={() => setActiveSection('security')}
                    >
                        Securitate
                    </button>
                </div>

                <div className="settings-content">
                    {activeSection === 'general' && (
                        <div className="settings-section">
                            <h2>Setări Generale</h2>
                            <div className="settings-group">
                                <div className="setting-item">
                                    <label>Nume Clinică:</label>
                                    <input
                                        type="text"
                                        value={settings.clinicName}
                                        onChange={(e) => updateSetting('clinicName', e.target.value)}
                                        className="setting-input"
                                    />
                                </div>
                                <div className="setting-item">
                                    <label>Email Contact:</label>
                                    <input
                                        type="email"
                                        value={settings.email}
                                        onChange={(e) => updateSetting('email', e.target.value)}
                                        className="setting-input"
                                    />
                                </div>
                                <div className="setting-item">
                                    <label>Telefon:</label>
                                    <input
                                        type="tel"
                                        value={settings.phone}
                                        onChange={(e) => updateSetting('phone', e.target.value)}
                                        className="setting-input"
                                    />
                                </div>
                                <div className="setting-item">
                                    <label>Adresă:</label>
                                    <textarea
                                        value={settings.address}
                                        onChange={(e) => updateSetting('address', e.target.value)}
                                        className="setting-textarea"
                                        rows={3}
                                    />
                                </div>
                                <div className="setting-item">
                                    <label>Limbă Sistem:</label>
                                    <select
                                        value={settings.language}
                                        onChange={(e) => updateSetting('language', e.target.value)}
                                        className="setting-select"
                                    >
                                        <option value="ro">Română</option>
                                        <option value="en">English</option>
                                    </select>
                                </div>
                                <div className="setting-item">
                                    <label>Fus Orar:</label>
                                    <select
                                        value={settings.timezone}
                                        onChange={(e) => updateSetting('timezone', e.target.value)}
                                        className="setting-select"
                                    >
                                        <option value="Europe/Bucharest">Europe/Bucharest</option>
                                        <option value="Europe/London">Europe/London</option>
                                        <option value="America/New_York">America/New_York</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeSection === 'working-hours' && (
                        <div className="settings-section">
                            <h2>Program de Lucru</h2>
                            <div className="working-hours">
                                {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
                                    <div key={day} className="working-day">
                                        <span className="day-label">
                                            {day === 'monday' ? 'Luni' :
                                                day === 'tuesday' ? 'Marți' :
                                                    day === 'wednesday' ? 'Miercuri' :
                                                        day === 'thursday' ? 'Joi' :
                                                            day === 'friday' ? 'Vineri' :
                                                                day === 'saturday' ? 'Sâmbătă' : 'Duminică'}:
                                        </span>
                                        <div className="time-inputs">
                                            <input
                                                type="time"
                                                value={settings.workingHours[day].start}
                                                onChange={(e) => updateWorkingHours(day, 'start', e.target.value)}
                                                className="time-input"
                                            />
                                            <span>până la</span>
                                            <input
                                                type="time"
                                                value={settings.workingHours[day].end}
                                                onChange={(e) => updateWorkingHours(day, 'end', e.target.value)}
                                                className="time-input"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {activeSection === 'notifications' && (
                        <div className="settings-section">
                            <h2>Setări Notificări</h2>
                            <div className="settings-group">
                                <div className="setting-item checkbox">
                                    <input
                                        type="checkbox"
                                        checked={settings.notifications}
                                        onChange={(e) => updateSetting('notifications', e.target.checked)}
                                        id="notifications"
                                    />
                                    <label htmlFor="notifications">Activează notificările sistem</label>
                                </div>
                                <div className="setting-item checkbox">
                                    <input
                                        type="checkbox"
                                        checked={settings.emailAlerts}
                                        onChange={(e) => updateSetting('emailAlerts', e.target.checked)}
                                        id="email-alerts"
                                    />
                                    <label htmlFor="email-alerts">Alerte prin email</label>
                                </div>
                                <div className="setting-item checkbox">
                                    <input
                                        type="checkbox"
                                        checked={settings.smsAlerts}
                                        onChange={(e) => updateSetting('smsAlerts', e.target.checked)}
                                        id="sms-alerts"
                                    />
                                    <label htmlFor="sms-alerts">Alarte prin SMS</label>
                                </div>
                                <div className="setting-item checkbox">
                                    <input
                                        type="checkbox"
                                        checked={settings.appointmentReminders}
                                        onChange={(e) => updateSetting('appointmentReminders', e.target.checked)}
                                        id="appointment-reminders"
                                    />
                                    <label htmlFor="appointment-reminders">Memento-uri programări</label>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeSection === 'booking' && (
                        <div className="settings-section">
                            <h2>Setări Programări</h2>
                            <div className="settings-group">
                                <div className="setting-item">
                                    <label>Durată implicită interval (minute):</label>
                                    <select
                                        value={settings.defaultSlotDuration}
                                        onChange={(e) => updateSetting('defaultSlotDuration', parseInt(e.target.value))}
                                        className="setting-select"
                                    >
                                        <option value={15}>15 minute</option>
                                        <option value={20}>20 minute</option>
                                        <option value={30}>30 minute</option>
                                        <option value={45}>45 minute</option>
                                        <option value={60}>60 minute</option>
                                    </select>
                                </div>
                                <div className="setting-item">
                                    <label>Rezervare în avans maxim (zile):</label>
                                    <input
                                        type="number"
                                        value={settings.maxAdvanceBooking}
                                        onChange={(e) => updateSetting('maxAdvanceBooking', parseInt(e.target.value))}
                                        className="setting-input"
                                        min={1}
                                        max={365}
                                    />
                                </div>
                                <div className="setting-item checkbox">
                                    <input
                                        type="checkbox"
                                        checked={settings.onlineBooking}
                                        onChange={(e) => updateSetting('onlineBooking', e.target.checked)}
                                        id="online-booking"
                                    />
                                    <label htmlFor="online-booking">Activează programările online</label>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeSection === 'security' && (
                        <div className="settings-section">
                            <h2>Setări Securitate</h2>
                            <div className="settings-group">
                                <div className="setting-item">
                                    <label>Contact Urgență:</label>
                                    <input
                                        type="tel"
                                        value={settings.emergencyContact}
                                        onChange={(e) => updateSetting('emergencyContact', e.target.value)}
                                        className="setting-input"
                                    />
                                </div>
                                <button className="action-btn warning">Schimbă Parola Administrator</button>
                                <button className="action-btn">Configurează 2FA</button>
                                <button className="action-btn">Gestionează Permisiuni</button>
                            </div>
                        </div>
                    )}

                    <div className="settings-actions">
                        <button className="cancel-btn">Anulează</button>
                        <button className="save-btn" onClick={handleSaveSettings}>Salvează Setările</button>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .settings-page {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .page-header {
                    margin-bottom: 2rem;
                }

                .page-header h1 {
                    color: #333;
                    margin-bottom: 0.5rem;
                }

                .page-header p {
                    color: #666;
                }

                .settings-container {
                    display: flex;
                    gap: 2rem;
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    overflow: hidden;
                }

                .settings-sidebar {
                    width: 250px;
                    background: #f8f9fa;
                    padding: 1rem 0;
                    border-right: 1px solid #e0e0e0;
                }

                .sidebar-btn {
                    display: block;
                    width: 100%;
                    padding: 1rem;
                    background: none;
                    border: none;
                    text-align: left;
                    cursor: pointer;
                    color: #666;
                    font-weight: 500;
                    border-left: 3px solid transparent;
                    transition: all 0.3s;
                }

                .sidebar-btn:hover {
                    background: #e9ecef;
                }

                .sidebar-btn.active {
                    background: white;
                    color: #667eea;
                    border-left-color: #667eea;
                }

                .settings-content {
                    flex: 1;
                    padding: 2rem;
                }

                .settings-section h2 {
                    color: #333;
                    margin-bottom: 2rem;
                    padding-bottom: 1rem;
                    border-bottom: 1px solid #e0e0e0;
                }

                .settings-group {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                .setting-item {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .setting-item label {
                    font-weight: 500;
                    color: #333;
                    font-size: 0.9rem;
                }

                .setting-input,
                .setting-select,
                .setting-textarea {
                    padding: 0.75rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    font-size: 1rem;
                }

                .setting-textarea {
                    resize: vertical;
                    min-height: 80px;
                }

                .setting-item.checkbox {
                    flex-direction: row;
                    align-items: center;
                    gap: 0.75rem;
                }

                .setting-item.checkbox input {
                    margin: 0;
                    transform: scale(1.2);
                }

                .working-hours {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }

                .working-day {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 1rem;
                    background: #f8f9fa;
                    border-radius: 4px;
                }

                .day-label {
                    font-weight: 600;
                    color: #333;
                    min-width: 100px;
                }

                .time-inputs {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .time-inputs span {
                    color: #666;
                }

                .time-input {
                    padding: 0.5rem;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                }

                .action-btn {
                    padding: 0.75rem 1.5rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: background 0.3s;
                    background: #6c757d;
                    color: white;
                    align-self: flex-start;
                    margin-top: 0.5rem;
                }

                .action-btn:hover {
                    background: #545b62;
                }

                .action-btn.warning {
                    background: #ffc107;
                    color: #212529;
                }

                .action-btn.warning:hover {
                    background: #e0a800;
                }

                .settings-actions {
                    margin-top: 3rem;
                    padding-top: 2rem;
                    border-top: 1px solid #e0e0e0;
                    display: flex;
                    justify-content: flex-end;
                    gap: 1rem;
                }

                .cancel-btn,
                .save-btn {
                    padding: 0.75rem 1.5rem;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 1rem;
                    transition: background 0.3s;
                }

                .cancel-btn {
                    background: #6c757d;
                    color: white;
                }

                .cancel-btn:hover {
                    background: #545b62;
                }

                .save-btn {
                    background: #28a745;
                    color: white;
                }

                .save-btn:hover {
                    background: #218838;
                }

                .page-navigation-header {
                    background: white;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-bottom: 2rem;
                    padding: 1rem;
                }

                .nav-header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem;
                }

                .back-to-dashboard {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 500;
                    padding: 0.5rem 1rem;
                    border-radius: 4px;
                    transition: background 0.3s;
                }

                .back-to-dashboard:hover {
                    background: #f8f9fa;
                }

                .quick-nav {
                    display: flex;
                    gap: 1rem;
                }

                .quick-nav-link {
                    padding: 0.5rem 1rem;
                    color: #666;
                    text-decoration: none;
                    border-radius: 4px;
                    font-weight: 500;
                    transition: all 0.3s;
                }

                .quick-nav-link:hover, .quick-nav-link.active {
                    background: #667eea;
                    color: white;
                }

                @media (max-width: 768px) {
                    .settings-container {
                        flex-direction: column;
                    }

                    .settings-sidebar {
                        width: 100%;
                        border-right: none;
                        border-bottom: 1px solid #e0e0e0;
                    }

                    .working-day {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 0.5rem;
                    }

                    .settings-actions {
                        justify-content: center;
                    }

                    .nav-header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .quick-nav {
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default Settings;
